module.exports = "/_next/static/images/dj-c33fb6a3b31067ceaa6e34e64d903eb9.svg";